function setCookie(obj, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    var m = exdate.toUTCString();
    var a = '';
    for (var i in obj) {
        document.cookie = i + "=" + escape(obj[i]) + "; expires=" + m + "; path=/";
    }
}
function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + '=');
        var c_end = void 0;
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            c_end = document.cookie.indexOf('; ', c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return '';
}
export default {
    setCookie: setCookie,
    getCookie: getCookie,
};
